import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { LocalizedTranslate, ToastProvider } from '@lp/portal-ui';
import { setApiClient } from './api.ts';
import { AiTranslateButton } from './components/AiTranslate.tsx';
import { router } from './router.tsx';
import './index.css';

async function start() {
  // Fake API for UI work before the backend exists. `import.meta.env.DEV` is false in production
  // builds, so this branch and the fixture module are dropped from the bundle.
  if (import.meta.env.DEV && import.meta.env.VITE_FIXTURES === '1') {
    const { createFixtureClient } = await import('./dev/fixtures.ts');
    setApiClient(createFixtureClient);
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ToastProvider>
        {/* 「AI 翻譯其他語言」 under every form's language tabs, for brands with the aiTranslate add-on. */}
        <LocalizedTranslate.Provider value={AiTranslateButton}>
          <RouterProvider router={router} />
        </LocalizedTranslate.Provider>
      </ToastProvider>
    </StrictMode>,
  );
}

void start();
